import { GET_PRODUCER } from "./Constants"

export const getProducer = ( dispatch, producerId ) => {
  dispatch({ type: GET_PRODUCER, payload: { producerId: producerId } })
}